import React, { useState, useEffect } from "react";
import { DraggableModal, Datagrid } from "/bbui/components/";
import { Input } from "antd";

const ModalAddDevice = ({
  modalDevicesProfile,
  onCancel,
  onSave,
  intl,
  devices,
  devicesSelected,
  group,
}) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: devices?.length || 0,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filteredData, setFilteredData] = useState(devices || []);

  useEffect(() => {
    const lower = filterValue.toLowerCase();
    const data = devices.filter((d) => {
    const value = d.name || d.text || "";
      return value.toLowerCase().includes(lower);
    });

    setFilteredData(data);
    setPagination((prev) => ({
      ...prev,
      total: data.length,
      current: 1,
    }));
  }, [filterValue, devices]);

  useEffect(() => {
    if (Array.isArray(devicesSelected)) {
      const ids = devicesSelected.map((d) => (typeof d === "object" ? d.id : d));
      setSelectedRowKeys(ids);
    }
  }, [devicesSelected]);


  const paginatedData = filteredData.slice(
    (pagination.current - 1) * pagination.pageSize,
    pagination.current * pagination.pageSize
  );

  const columns = [
    {
      title: "Devices",
      dataIndex: "name",
      width: "90%",
      ellipsis: true,
      render: (_, d) => <span>{d.name || d.text || "-"}</span>,
    },
  ];

  const bulkActions = [
    {
      key: "selectAll",
      text: intl.formatMessage({ id: "common.selectAll" }),
      onClick: () => {
        const allFilteredIds = filteredData.map((item) => item.id);
        const unique = Array.from(
          new Set([...selectedRowKeys, ...allFilteredIds])
        );
        setSelectedRowKeys(unique);
      },
    },
    {
      key: "deselectAll",
      text: intl.formatMessage({ id: "common.deselectAll" }),
      onClick: () => {
        const remaining = selectedRowKeys.filter(
          (id) => !filteredData.some((item) => item.id === id)
        );
        setSelectedRowKeys(remaining);
      },
    },
  ];

const idIsNumber = typeof (devices?.[0]?.id) === 'number';
const normId = v => (idIsNumber ? Number(v) : String(v));

const rowSelection = {
  selectedRowKeys,
  preserveSelectedRowKeys: true,
  onChange: (keys) => setSelectedRowKeys(keys.map(normId)),

  onSelectAll: (selected, _selectedRows, changeRows) => {
    const pageRows = (changeRows && changeRows.length) ? changeRows : paginatedData;
    const pageIds  = pageRows.map(r => normId(r.id));

    setSelectedRowKeys(prev => {
      const set = new Set(prev.map(normId));
      if (selected) {
        pageIds.forEach(id => set.add(id));
      } else {
        pageIds.forEach(id => set.delete(id));
      }
      return Array.from(set);
    });
  },
};

  const handleChange = (pag,filter) => {
    setPagination(pag);
    setFilterValue(filter)
  };

  return (
    <DraggableModal
      width={780}
      onCancel={onCancel}
      cancelText={intl.formatMessage({ id: "common.cancel" })}
      onOk={() => onSave(selectedRowKeys)}
      okText={intl.formatMessage({ id: "common.save" })}
      visible={modalDevicesProfile}
      title={intl.formatMessage({
        id:
          "id" in group
            ? "devices.manager.groupModal.title.edit"
            : "devices.manager.groupModal.title.create",
      })}
    >
      {/* <div style={{ marginBottom: 12 }}>
        <Input.Search
          allowClear
          placeholder="Filtrar por nome do dispositivo"
          value={filterValue}
          onChange={(e) => setFilterValue(e.target.value)}
        />
      </div> */}
        <Datagrid
          id="add-devices"
          bulkActions={bulkActions}
          columns={columns}
          rowSelection={rowSelection}
          dataSource={paginatedData}
          pagination={pagination}
          onChange={handleChange}
          total={pagination.total}
          filter={true}
          labels={
            pagination.total > 1
              ? { records: intl.formatMessage({ id: "common.records" }) }
              : { records: intl.formatMessage({ id: "common.record" }) }
          }
          scroll={{ y: 300 }}
        />
    </DraggableModal>
  );
};

export default ModalAddDevice;
